import React from "react";
import ImageItemsWebView from "./ImageItemsWebView";

function PicCatalogWebComponent(props) {
  const { columns, sections, textColor } = props;

  return (
    <div style={{ width: "100%" }}>
      {sections &&
        sections.map((s, idx) => {
          if (s.images.length > 0) {
            return (
              <div key={idx}>
                <p
                  style={{
                    ...s.header,
                    position: "relative",
                    textAlign: "center",
                    margin: "0.5em",
                    color: textColor,
                  }}
                >
                  {s.header.text}
                </p>
                {s.images && (
                  <ImageItemsWebView
                    columns={columns}
                    images={s.images}
                    textColor={textColor}
                  />
                )}
              </div>
            );
          }
        })}
    </div>
  );
}

export default PicCatalogWebComponent;
